interface XPProgressBarProps {
  currentXP: number;
  needed: number;
  percent: number;
  level: number;
}

export function XPProgressBar({ currentXP, needed, percent, level }: XPProgressBarProps) {
  return (
    <div className="flex items-center gap-3">
      <div className="w-8 h-8 bg-gradient-to-br from-violet-500 to-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
        <span className="text-xs font-bold text-fg">{level}</span>
      </div>
      <div className="flex-1">
        <div className="h-2 bg-overlay-2 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-violet-500 to-purple-500 rounded-full transition-all duration-700"
            style={{ width: `${percent}%` }}
          />
        </div>
        <div className="flex justify-between mt-1">
          <span className="text-[10px] text-fg-faint">{currentXP}/{needed} XP</span>
          <span className="text-[10px] text-fg-faint">Niveau {level + 1}</span>
        </div>
      </div>
    </div>
  );
}
